export const events = {
  visitsNpsPage: 'Visits main NPS page',
  submitNpsAnswer: 'Submits a new NPS survey answer',
  completesScoringStep: 'Completes Scoring step in NPS widget',
  completesFeedbackStep: 'Completes Feedback step in NPS widget',
  closesWidget: 'Closes NPS widget',
  viewsWidget: 'Views NPS widget',
  clickReview: 'Clicks on a review platform',
  clickReferralProgram: 'Clicks on the referral program',
}
